import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import chatListSagas from './chatList/saga';
import availablityListSagas from './availablity/saga';
import bookingListSagas from './bookings/saga';
import ticketListSagas from './ticketList/saga';
import createTicketSagas from './createTicket/saga';
import userSagas from './users/saga';
import signalSagas from './signalr/saga';
import serviceSaga from './service/saga';
import twilioConversationsSaga from './twilioConversations/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    chatListSagas(),
    availablityListSagas(),
    bookingListSagas(),
    ticketListSagas(),
    createTicketSagas(),
    userSagas(),
    signalSagas(),
    serviceSaga(),
    twilioConversationsSaga(),
  ]);
}
